
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import Testimonials from './TestimonialKeyword';
import Accordion from './Accordion';

function Ertigaonrentinpune() {



    const cardData =
    {
        keyword: 'Ertiga On Rent in Pune',
        heading: 'Meghana Cab : Ertiga On Rent in Pune',
        headingDescription: 'Meghana Cab offers Ertiga on Rent in Pune, delivering a spacious, reliable, and comfortable travel solution for families, corporate groups, or weekend getaways. Whether you need it for local sightseeing, airport transfers, or long outstation drives, our well-maintained Ertiga with experienced drivers ensures a smooth and safe journey. With flexible hourly and daily packages, transparent pricing, 24/7 support, and doorstep pickup/drop, renting an Ertiga in Pune has never been more easy and stress-free.',


        top: 'Top Places to Visit in Pune with Meghana Cab',

"topPlaces": [
  {
    "title": "Shaniwar Wada",
    "description": "Shaniwar Wada is a majestic palace-fort in the heart of Pune, originally built in 1730 AD by the Peshwas. Its grand gates, ornate balconies, and spacious courtyards reflect the glory of Maratha architecture. Though much was destroyed by fire, the remaining ruins echo tales of intrigue, power, and royal life. Evening light-and-sound shows narrate its history, drawing locals and tourists alike. The gardens and pathways are perfect for leisurely strolls. Close to Dagdusheth Ganapati, it anchors the city’s old-town heritage precinct."
  },
  {
    "title": "Aga Khan Palace",
    "description": "Aga Khan Palace is a serene, sprawling memorial where Mahatma Gandhi, Kasturba Gandhi, and other freedom fighters were interned during India’s Quit India Movement. Its graceful domes, imposing pillars, and lush gardens offer a peaceful retreat. The small museum inside displays letters, photographs, and personal items of Gandhi, making it both spiritual and educational. The garden's paths and fountains invite reflective walks. It also symbolizes Pune’s role in India’s struggle for independence."
  },
  {
    "title": "Pataleshwar Cave Temple",
    "description": "Embedded in the city’s core, Pataleshwar is an 8th-century rock-cut cave temple first carved during the Rashtrakuta era. Though modest in scale, its monolithic excavation, pillared hall, and Nandi shrine convey an aura of ancient artistry and devotion. It’s surprising to find such calm in bustling Pune. The surrounding garden and shaded areas make it a quiet retreat. Photography is limited inside, ensuring the sanctity of this sacred site. A visit here connects city walkers to Pune’s hidden historic soul."
  },
  {
    "title": "Pune-Okayama Friendship Garden (Pu La Deshpande Garden)",
    "description": "Also called the Pu La Deshpande Udyan, this garden is Pune’s Japanese-style oasis inspired by Okayama’s Koraku-en Garden. Spread across 10 acres, the garden features meandering walkways, gently flowing water canals, stone bridges, koi ponds, and manicured landscaping. It’s an ideal spot for morning walks, poetry reading, or quiet meditation. The balance of water, stone, and green spaces makes it especially soothing during monsoons. Locals often visit for picnics and family time."
  },
  {
    "title": "ISKCON NVCC Temple",
    "description": "ISKCON NVCC (New Vedic Cultural Center) is a beautiful temple complex located in Kondhwa, Pune, dedicated to Radha-Krishna and Venkateswara (Balaji). Built with red sandstone, marble, and intricate carvings, its architecture blends North and South styles. The temple hosts daily kirtans, Gita classes, and spiritual discourses. The sacred ambiance, pristine gardens, and calm prayer halls invite visitors seeking peace and devotion. It’s also a spiritual landmark amidst Pune’s urban sprawl."
  },
  {
    "title": "Sinhagad Fort",
    "description": "Perched about 25 km southwest of Pune, Sinhagad is a legendary hill fort with dramatic views over the surrounding valleys. The trek to the fort is famed—especially during monsoon—through lush greenery and rugged terrain. At the top, ruins of bastions, gates, and water tanks await exploration. The fort witnessed heroic battles (e.g. Tanaji’s sacrifice) and still resonates with tales of Maratha valor. Early morning visits reward you with sunrise, fresh mountain air, and quiet reflections far from the city bustle."
  },
  {
    "title": "Karla and Bhaja Caves",
    "description": "On the outskirts of Pune lie the ancient Buddhist rock-cut caves of Karla and Bhaja, dating back over 2,000 years. Karla has one of India’s largest chaityas (prayer halls), while Bhaja features intricate carvings, stupas, and dancing figures. The approach involves a short nature walk, passing scenic hills and greenery. The caves reflect India’s early Buddhist heritage and artistic brilliance. They’re ideal for history buffs, spiritual seekers, and nature lovers alike—blending culture with tranquility."
  },
  {
    "title": "Tikona Fort",
    "description": "Situated about 60 km from Pune in Maval, Tikona Fort (also called Vitandgad) is a pyramidal hill fort ideal for trekking and panoramic views. The ascent leads you past seven natural water tanks, remains of old stone gates, and ASI-protected ruins. At the top, you get sweeping vistas of Pawna reservoir, nearby forts like Lohagad and Visapur, and rolling hills. It’s a moderately challenging but rewarding hike, especially enjoyed during monsoon when the hills are lush and misty."
  },
  {
    "title": "Bal Gandharva Ranga Mandir",
    "description": "Bal Gandharva Ranga Mandir is a prominent cultural theatre in Shivajinagar, Pune, named after the famous Marathi singer-actor Bal Gandharva. With a seating capacity of nearly 1,000, it hosts regular Marathi and Hindi plays, musicals, exhibitions, and cultural events. The building also has an exhibition hall showcasing theatre memorabilia. Visiting a performance here offers immersive insight into Pune’s vibrant performing arts scene. Even the surroundings—tree-lined streets, street cafés—echo local life and artistry."
  },
  {
    "title": "Vishrambaug Wada & Lal Mahal",
    "description": "Vishrambaug Wada and Lal Mahal are heritage mansions hidden within Pune’s wadas (old quarters). Wadas were traditional townhouses of Maratha nobility. Vishrambaug Wada still has intricately carved wooden balconies, internal courtyards, and a sense of the bygone era. Near it lies Lal Mahal, once home to Shivaji Maharaj as a young prince. Though much of Lal Mahal is reconstructed, it houses a small museum and replicates Maratha-era life. Exploring these gives you a walking-tour feel of old Pune’s lanes, stories, and royal past."
  }
],

        "services": [
    {
      "name": "Ertiga on Rent in Pune",
      "description": "Rent a Maruti Ertiga in Pune with Meghana Cab for a spacious, comfortable, and fuel-efficient travel experience. Perfect for families and small groups, our Ertiga rental cars come well-maintained with modern amenities, including air conditioning and ample luggage space. Whether you need a car for local travel or outstation trips, enjoy affordable rates and reliable service across Pune and surrounding areas."
    },
    {
      "name": "Ertiga CNG on Rent in Pune",
      "description": "Opt for eco-friendly and economical travel by renting an Ertiga CNG car in Pune. Meghana Cab offers CNG-fueled Ertiga vehicles that combine fuel efficiency with comfort, making them an ideal choice for daily commutes or long-distance travel. Our CNG Ertigas are regularly serviced and driven by experienced drivers to ensure a safe and pleasant journey."
    },
    {
      "name": "Ertiga Rent per Km in Pune",
      "description": "Looking for cost-effective Ertiga rental in Pune? Meghana Cab provides transparent pricing with competitive per kilometer rates for Ertiga rentals. Our fare includes all standard charges, with no hidden costs, so you can enjoy your trip without worrying about extra fees. Contact us for detailed pricing based on your travel distance and package preferences."
    },
    {
      "name": "Pune to Mahabaleshwar Ertiga Cab",
      "description": "Travel comfortably from Pune to Mahabaleshwar in a spacious Ertiga cab. Ideal for family trips and small groups, our Pune to Mahabaleshwar Ertiga service offers a smooth ride through scenic routes with ample luggage space and air conditioning. Choose flexible packages including day tours and overnight stays, complete with professional drivers familiar with the best local spots."
    },
    {
      "name": "Pune to Mumbai Ertiga Cab",
      "description": "Book an Ertiga cab from Pune to Mumbai for a comfortable, hassle-free journey. Whether you're headed to the Mumbai airport, business meetings, or sightseeing, our Ertiga cabs provide the perfect blend of space and luxury. Enjoy timely pickups, courteous drivers, and competitive pricing for your Pune to Mumbai trips."
    },
    {
      "name": "Pune to Nashik Ertiga Cab Booking",
      "description": "Make your Pune to Nashik journey relaxing and enjoyable with Meghana Cab’s Ertiga cab service. Our vehicles come fully equipped with air conditioning and safety features to ensure a smooth ride. Perfect for wine tours, religious visits, or business travel, our flexible booking options allow you to customize your trip according to your needs."
    },
    {
      "name": "Pune to Shirdi Ertiga Cab Booking",
      "description": "Travel to the holy city of Shirdi from Pune in comfort with our Ertiga cab booking. Ideal for pilgrims and tourists alike, our service provides reliable pickups, spacious seating, and knowledgeable drivers to enhance your spiritual journey. Enjoy affordable fares and convenient package options tailored for your Shirdi trip."
    },
    {
      "name": "Pune to Goa Ertiga Cab",
      "description": "Enjoy a comfortable and scenic road trip from Pune to Goa in a spacious Ertiga cab. Meghana Cab offers well-maintained vehicles with air conditioning and experienced drivers to make your long-distance travel relaxing and safe. Choose from one-way or round-trip packages to suit your itinerary."
    },
    {
      "name": "Ertiga Hire in Pimpri Chinchwad, Aundh, Baner, Hinjewadi, Viman Nagar, Kharadi, Hadapsar, Magarpatta",
      "description": "Meghana Cab provides convenient Ertiga hire services across Pune suburbs including Pimpri Chinchwad, Aundh, Baner, Hinjewadi, Viman Nagar, Kharadi, Hadapsar, and Magarpatta. Whether you need an Ertiga for corporate travel, family outings, or daily commutes, our well-maintained cars and professional drivers are ready to serve you with punctual and friendly service in every locality."
    },
    {
      "name": "Kolhapur to Pune Ertiga Cab Booking",
      "description": "Book an Ertiga cab for your trip from Kolhapur to Pune with Meghana Cab. Our spacious and comfortable Ertiga vehicles ensure a safe and enjoyable journey, perfect for families and groups traveling between these cities. Experience door-to-door service, transparent pricing, and hassle-free booking."
    }
  ],
  "tableData": [
    ["Ertiga on Rent in Pune", "Ertiga CNG on Rent in Pune"],
    ["Ertiga Rent per Km in Pune", "Pune to Mahabaleshwar Ertiga Cab"],
    ["Pune to Mumbai Ertiga Cab", "Pune to Nashik Ertiga Cab Booking"],
    ["Pune to Shirdi Ertiga Cab Booking", "Pune to Goa Ertiga Cab"],
    ["Ertiga Hire in Pune Suburbs", "Kolhapur to Pune Ertiga Cab Booking"]
  ],











"whychoose": [
    {
        "WhyChooseheading": "Spacious and Comfortable Ertiga Rentals",
        "WhyChoosedescription": "Meghana Cab offers the Maruti Suzuki Ertiga for rent in Pune, providing a spacious and comfortable ride for families, groups, or business trips. Enjoy ample legroom and a smooth journey."
    },
    {
        "WhyChooseheading": "Flexible Rental Options",
        "WhyChoosedescription": "Choose from daily, weekly, or monthly rental plans to suit your travel needs. Whether it's a short trip or an extended stay, Meghana Cab has flexible options to accommodate your schedule."
    },
    {
        "WhyChooseheading": "Affordable Pricing with Transparent Rates",
        "WhyChoosedescription": "Enjoy competitive pricing with no hidden charges. Meghana Cab offers clear and upfront pricing, ensuring you get the best value for your money."
    },
    {
        "WhyChooseheading": "Well-Maintained and Sanitized Vehicles",
        "WhyChoosedescription": "Travel in a well-maintained and sanitized Ertiga, ensuring a safe and hygienic environment. Regular cleaning and maintenance are a priority for Meghana Cab."
    },
    {
        "WhyChooseheading": "Experienced and Professional Drivers",
        "WhyChoosedescription": "Our drivers are experienced and professional, ensuring a safe and pleasant journey. They are familiar with Pune's routes and are committed to providing excellent service."
    },
    {
        "WhyChooseheading": "24/7 Availability for Your Convenience",
        "WhyChoosedescription": "Meghana Cab offers 24/7 availability, allowing you to rent an Ertiga at any time that suits you. Whether it's an early morning trip or a late-night return, we've got you covered."
    },
    {
        "WhyChooseheading": "Easy Online Booking and Customer Support",
        "WhyChoosedescription": "Book your Ertiga rental easily through our website or app. Our customer support team is always ready to assist you with bookings and any queries you may have."
    },
    {
        "WhyChooseheading": "Customizable Itineraries to Suit Your Needs",
        "WhyChoosedescription": "Customize your travel itinerary with Meghana Cab. Whether it's a local sightseeing tour or an outstation trip, we can tailor the journey to meet your specific requirements."
    }
]
























    }




const faqData = [
    {
        question: "How can I book an Ertiga on rent in Pune with Meghana Cab?",
        answer: "You can book an Ertiga on rent in Pune easily through Meghana Cab’s website or by calling our customer service at +91 9075462128."
    },
    {
        question: "What is the rental rate for an Ertiga in Pune?",
        answer: "The rental rate for an Ertiga in Pune varies depending on the duration and type of service. For example, Shashikala Tours & Travels offers Ertiga rentals at ₹14.00 per km, with a daily package of ₹4,200 for 300 km/day."
    },
    {
        question: "Is a driver included in the Ertiga rental?",
        answer: "Yes, the rental includes the car, driver, and diesel. However, tolls, parking, and driver food are extra."
    },
    {
        question: "Can I rent an Ertiga for outstation trips from Pune?",
        answer: "Yes, Ertiga rentals are available for outstation trips from Pune. For instance, Vighnaharta Travels offers Ertiga rentals for outstation trips at ₹4,500 for 300 km."
    },
    {
        question: "Are there self-drive options available for Ertiga rentals in Pune?",
        answer: "Yes, self-drive options are available. For example, NobuyRent offers a self-drive Suzuki Ertiga for ₹3,700 per day."
    },
    {
        question: "What is the seating capacity of the Ertiga?",
        answer: "The Ertiga can comfortably accommodate up to 6 passengers."
    },
    {
        question: "Are the Ertiga vehicles well-maintained?",
        answer: "Yes, all Ertiga vehicles are well-maintained, clean, and equipped with all necessary amenities to ensure a comfortable journey."
    },
    {
        question: "How do I contact Meghana Cab to book an Ertiga on rent in Pune?",
        answer: "You can contact Meghana Cab at +91 9075462128 for bookings and support."
    }
];

const testimonialsData = [
    {
        name: 'Mr. Sameer P.',
        designation: 'Customer',
        rating: [1, 1, 1, 1, 1],
        text: '“I rented an Ertiga from Shiv Cabs for a family trip to Mahabaleshwar, and the experience was wonderful. The cab was spacious and comfortable, and the driver was very professional.”',
    },
    {
        name: 'Miss. Neha Sharma',
        designation: 'Customer',
        rating: [1, 1, 1, 1, 1],
        text: '“Pawar Car Rentals made our family vacation in Pune so much easier! We rented the Ertiga for a week-long trip, and the car was perfect. Spacious, well-maintained, and comfortable for our long drives.”',
    },
];











































    const contactData = {
        heading: `${cardData.keyword} Contact Number`,
        contactNumbers: [
            "+91 9075462128",
            "+91 8452916550",

        ],
        email: "booking@meghanacabs.com"
    };


    const Images = [
        {
            place: "/images/keyword/1.jpg",
            text: "Online Cab Booking in Pune",
        },
        {
            place: "/images/keyword/2.jpg",
            text: "Pune to Kolhapur Cab",
        },
        {
            place: "/images/keyword/3.jpg",
            text: "Pune to Satara Cab",
        },
        {
            place: "/images/keyword/4.jpg",
            text: "Pune to Hyderabad Cab",
        },
        {
            place: "/images/keyword/5.jpg",
            text: "Pune to Bangalore Cab",
        },
        {
            place: "/images/keyword/6.jpg",
            text: "Pune to Indore Cab",
        },
        {
            place: "/images/keyword/7.jpg",
            text: "Pune to Gujarat Cab",
        },

        {
            place: "/images/keyword/8.jpg",
            text: "Pune to Lonavala Taxi",
        },

        {
            place: "/images/keyword/9.jpg",
            text: "Pune to Jejuri Cab",
        },
        {
            place: "/images/keyword/10.jpg",
            text: "Local Taxi Service in Pune",
        },

        {
            place: "/images/keyword/11.jpg",
            text: "Pune to Lavasa Cab",
        },
        {
            place: "/images/keyword/12.jpg",
            text: "Pune to Kashid Beach Cab",
        },

        {
            place: "/images/keyword/13.jpg",
            text: "One Way Cab Pune",
        },

        {
            place: "/images/keyword/14.jpg",
            text: "Round Trip Cab",
        },
        {
            place: "/images/keyword/15.jpg",
            text: "Taxi Service Near Me",
        },
        {
            place: "/images/keyword/16.jpg",
            text: " Car Hire in Pune",
        },
        {
            place: "/images/keyword/17.jpg",
            text: "Seater Car on Rent in Pune",
        },
        {
            place: "/images/keyword/18.jpg",
            text: "Cab Service in Pimpri Chinchwad",
        },
        {
            place: "/images/keyword/19.jpg",
            text: "Pune Taxi Cab Services",
        },
        {
            place: "/images/keyword/20.jpg",
            text: "Pune Airport Taxi",
        },

        {
            place: "/images/keyword/21.jpg",
            text: "Pune to Rajasthan Cab",
        },
        {
            place: "/images/keyword/22.jpg",
            text: "Pune to Matheran Cab",
        },
        {
            place: "/images/keyword/23.jpg",
            text: "Pune to Pandharpur Cab",
        },
        {
            place: "/images/keyword/24.jpg",
            text: " Pune to Mumbai Cabs",
        },
        {
            place: "/images/keyword/25.jpg",
            text: "Pune to Mumbai Airport Cab ",
        },
        {
            place: "/images/keyword/26.jpg",
            text: " Pune to Mumbai Taxi",
        },
    ];


    const images = [
        { src: "/images/booking/1.jpg", alt: "Image 1" },
        { src: "/images/booking/5.jpg", alt: "Image 1" },
        { src: "/images/booking/2.jpg", alt: "Image 1" },
        { src: "/images/booking/3.jpg", alt: "Image 1" },
        { src: "/images/booking/4.jpg", alt: "Image 1" },
        { src: "/images/booking/7.jpg", alt: "Image 1" },
        { src: "/images/booking/8.jpg", alt: "Image 1" },
        { src: "/images/booking/9.jpg", alt: "Image 1" },
        { src: "/images/booking/6.jpg", alt: "Image 1" },

    ];








const jsonData = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Ertiga On Rent in Pune",
  "description": "Book Ertiga on rent in Pune with Meghana Cabs for comfortable family trips, corporate travel, and outstation journeys. Affordable Ertiga rental rates per km with well-maintained vehicles and professional drivers.",
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.9",
    "ratingCount": "4786"
  }
};




    return (
        <div>


<Helmet>
  <title>Ertiga On Rent in Pune | Affordable Ertiga Car Rental @ Meghana Cabs</title>
  <meta
    name="description"
    content="Get Ertiga on rent in Pune with Meghana Cabs. Affordable Ertiga rental for local and outstation trips including Mumbai, Mahabaleshwar, Nashik, Shirdi, Goa, and more. Comfortable rides at the best rates per km."
  />
  <meta
    name="keywords"
    content="Ertiga on rent in pune, Ertiga on rent pune, Ertiga car on rent in pune, Ertiga cng on rent in pune, Ertiga rent in pune, ertiga rent per km in pune, ertiga rental pune, maruti ertiga on rent in pune, pune to mahabaleshwar ertiga cab, pune to mahabaleshwar cab for 2 days, pune to mahabaleshwar ertiga booking, pune to mahabaleshwar tour package, pune to mumbai ertiga cab, pune to mumbai airport ertiga cab, pune to nashik ertiga cab booking, pune to shirdi ertiga cab booking, pune to goa ertiga Cab, pune to lonavala Ertiga Cab, kolhapur to pune ertiga cab booking, pune to kolhapur Ertiga Cab, ertiga hire in pimpri chinchwad, ertiga hire in aundh baner, ertiga hire in hinjewadi pune, ertiga rent per km in pune, ertiga cabs in viman nagar pune, Ertiga on rent in kharadi, ertiga cab in hadapsar magarpatta"
  />
  <script type="application/ld+json">
    {JSON.stringify(jsonData)}
  </script>
</Helmet>




            <section className="page-title centred">
                <div className="bg-layer" style={{ backgroundImage: 'url(/images/page-header-bg.jpg)' }}></div>
                <div className="auto-container">
                    <div className="content-box">

                        <h1>{cardData.keyword}</h1>
                    </div>
                </div>
            </section>




            <section>
                <div className="container-fluid" >
                    <div className="row ">
                        <div className="col-12 col-md-7 ">
                            <img src='/images/keyword/64.jpg' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#F2614C', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="">
                                <p className='fw-bold py-3 darkcolorrr'>{cardData.top}</p>
                                {cardData.topPlaces.map((place, index) => (
                                    <div key={index} className="">
                                        <div
                                            style={{
                                                cursor: 'pointer',
                                                padding: '10px',
                                                marginBottom: '7px',
                                                borderRadius: '8px',
                                                transition: 'transform 0.2s'
                                            }}

                                        >
                                            <h4 className="mb-1 darkcolorrr">{place.title}</h4>
                                            <p className="mb-0">{place.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            <div
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    marginBottom: '7px',
                                    borderRadius: '8px', // Optional: rounded corners
                                    transition: 'transform 0.2s' // Optional: smooth scaling effect
                                }}
                            >
                                {cardData.services.map((service, index) => (
                                    <div key={index} className=" my-4">
                                        <h4 className="py-1 darkcolorrr">{service.name}</h4>
                                        <p>{service.description}</p>
                                    </div>
                                ))}
                            </div>

                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                             <h3 className='pt-md-3 text-dark'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section"
                                className='px-2'>
                                <h2 className='whycolor py-3'>Why Choose us for  {cardData.keyword}</h2>
                                {cardData.whychoose.map((item, index) => (
                                    <div key={index}>
                                        <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                                        <p>{item.WhyChoosedescription}</p>
                                    </div>
                                ))}
                            </div>


                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark darkcolor">FAQS {cardData.keyword} For Meghana Cabs </h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">
                                                <Accordion data={faqData} />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <Testimonials testimonials={testimonialsData} />


                            <div className='py-4'>

                                <div className="contact-box Borderr">
                                    <h3 className=' text-dark'>{contactData.heading}</h3>
                                    <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                                    <div className="contact-details">
                                        <p><strong className='darkcolor'>Mobile No:</strong></p>
                                        <ul>
                                            {contactData.contactNumbers.map((number, index) => (
                                                <li key={index}>
                                                    <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                                                        {number}
                                                    </a>
                                                </li>
                                            ))}
                                        </ul>
                                        <p><strong className='darkcolor'>Email Id: </strong>
                                            <a href={`mailto:${contactData.email}`} className="contact-link">
                                                {contactData.email}
                                            </a>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='col-12 col-md-4' >
                            {Images.map((e) => {
                                return (
                                    <div className="box1">
                                        <a
                                            href="./"
                                            className="d-flex justify-content-around align-items-center"
                                        >
                                            <div className="b1">
                                                <img src={e.place} alt="img" />
                                            </div>
                                            <div className="b2">
                                                {" "}
                                                <a href="./" className='px-3'>{e.text}</a>
                                            </div>
                                        </a>
                                    </div>
                                );
                            })}


                            <div className="gallery-container">
                                <h2 className="gallery-title">Our Fleets</h2>
                                <div className="gallery-row d-flex flex-wrap">
                                    {images.map((image, index) => (
                                        <div className="gallery-item col-md-4" key={index}>
                                            <img
                                                src={image.src}
                                                alt={image.alt}
                                                className="gallery-image"

                                            />
                                        </div>
                                    ))}

                                </div>
                            </div>

                            <div className=" rounded p-4 shadow-sm Uni_border "
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    border: '3px dotted #F1604F',
                                    marginBottom: '7px',
                                    fontWeight: 'bold',
                                }}

                            >
                                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                                <div className="row">

                                    <div className="col-12 mb-3">
                                        <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#F1604F' }}>
                                            <h4 className=" lead fw-semibold whitt text-darkk">Phone Numbers</h4>
                                            <i className="bi bi-telephone-fill fs-1 mb-2"></i>
                                            <div className=''>
                                                <a href="tel:+919075462128" className="d-block  text-white">+91 9075462128</a>
                                                <a href="tel:+918452916550" className="d-block  text-white">+91 8452916550</a>



                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border rounded text-center">
                                            <i className="bi bi-envelope fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#F1604F' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk">Email</h4>
                                                <a href="mailto:booking@meghanacabs.com" className=" text-white d-block">
                                                    booking@meghanacabs.com
                                                </a>
                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border  rounded text-center">
                                            <i className="bi bi-house-fill fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#F1604F' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk">Address</h4>
                                                <p className="whit text-white ">
                                                    <i> Meghana Cab  <br />
                                                        Yelwande Wasti. Opp Vithal Lawans, Laxmi Chowk, Hinjawadi, Pune - 411057
                                                    </i>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>



                        </div>
                    </div>
                </div>
            </section>



        </div>
    );
}

export default Ertigaonrentinpune;